module.exports = __webpack_public_path__ + "img/t_0032.8a8cfd03.gif";